// src/pages/Home/Header.jsx
import React, { useState, useEffect } from "react";
import { getSettings } from "../../services/settingsServices";
import "./HeaderSlider.css";

const Header = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [slides, setSlides] = useState([]);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const settings = await getSettings();
        if (settings.length > 0) {
          const s = settings[0];
          const headers = [];

          if (s.header_url1) {
            headers.push({
              src: s.header_url1,
              text: s.header_texte1,
              align: "left",
            });
          }

          if (s.header_url2) {
            headers.push({
              src: s.header_url2,
              text: s.header_texte2,
              align: "right",
            });
          }

          setSlides(headers);
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des paramètres:", error);
      }
    };

    fetchSettings();
  }, []);

  useEffect(() => {
    if (slides.length <= 1) return;
    const timeout = setTimeout(() => {
      setCurrentIndex((prev) => (prev + 1) % slides.length);
    }, 8000);

    return () => clearTimeout(timeout);
  }, [currentIndex, slides]);

  if (!slides.length) {
    return (
      <div className="header-hero-skeleton">
        <div className="header-skeleton-inner">
          Chargement des visuels du comité...
        </div>
      </div>
    );
  }

  const activeSlide = slides[currentIndex];

  return (
    <header className="header-hero">
      {/* Slides d'arrière-plan */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`header-slide ${
            index === currentIndex ? "active" : "inactive"
          }`}
        >
          {slide.src && (
            <img
              src={slide.src}
              alt={`Visuel comité ${index + 1}`}
              className="header-slide-image"
            />
          )}
          <div className="header-slide-overlay" />
        </div>
      ))}

      {/* Contenu par-dessus */}
      <div className="header-content">
        <div
          className={`header-content-inner ${
            activeSlide.align === "right"
              ? "header-content-right"
              : "header-content-left"
          }`}
        >
          <div
            className="header-text"
            dangerouslySetInnerHTML={{ __html: activeSlide.text }}
          />

          <div className="header-cta-row">
            <a href="#events" className="btn-primary-header">
              Voir le calendrier
            </a>
            <a href="#contact" className="btn-outline-header">
              Contacter le comité
            </a>
          </div>
        </div>

        {/* Dots de navigation */}
        {slides.length > 1 && (
          <div className="header-dots">
            {slides.map((_, i) => (
              <button
                key={i}
                type="button"
                className={`header-dot ${i === currentIndex ? "active" : ""}`}
                onClick={() => setCurrentIndex(i)}
              />
            ))}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
